const translations = {
  "en": {
    "Information for you": "Information for you"
  },
  "zh-tw": {
    "Information for you": "專屬你的情報"
  }
};

export default translations;
